import { Constants } from "@/types/services/constants";

export const constants: Constants = {
  GENERAL_TERMS_URL: "https://jfrog.com/cloud-terms-and-conditions/",
  PRIVACY_POLICY_URL: "https://jfrog.com/privacy-policy/",
};
